import { Component, Inject, AfterViewInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface DialogData {}

@Component({
  selector: "tax-code-dialog",
  templateUrl: "tax-code-dialog.html",
})
export class TaxCodeDialog implements AfterViewInit {
  constructor(
    public dialogRef: MatDialogRef<TaxCodeDialog>,
    @Inject(MAT_DIALOG_DATA) private data: DialogData
  ) {}

  ngAfterViewInit() {}
}
